var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Field, reduxForm } from "redux-form/immutable";
import PropTypes from "prop-types";
import countriesMap from "../../shared/dictionaries/countries/ru.json";
import { FormattedMessage, defineMessages, injectIntl } from "react-intl";
import renderDatePicker from "../shared/renderDatePicker.jsx";
import ProfileInput from "./ProfileInput.jsx";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import moment from "moment";
var renderSelectField = function (_a) {
    var input = _a.input, data = _a.data, _b = _a.meta, touched = _b.touched, error = _b.error, warning = _b.warning;
    var inputCls = touched && error ? "recharge-error" : "";
    return (_jsxs("div", __assign({ className: "select", style: { height: "auto", outline: 'none', background: 'white', border: '1px solid #C2C2BE', padding: 0, marginBottom: 17 } }, { children: [_jsxs("select", __assign({ className: inputCls }, input, { style: { outline: 'none', width: '100%', padding: '0px 10px', fontSize: 14 } }, { children: [_jsx(FormattedMessage, __assign({}, messages.profile_country, { children: function (m) { return _jsx("option", __assign({ style: { width: '100%' }, value: "" }, { children: m })); } })), data] })), touched &&
                ((error && (_jsx("span", __assign({ style: { color: "red", marginLeft: "5px" } }, { children: error })))) ||
                    (warning && _jsx("span", { children: warning })))] })));
};
var messages = defineMessages({
    profile_login: {
        id: "profile.login",
        defaultMessage: "Login"
    },
    profile_name: {
        id: "profile.name",
        defaultMessage: "Имя"
    },
    profile_surname: {
        id: "profile.surname",
        defaultMessage: "Фамилия"
    },
    profile_email: {
        id: "profile.email",
        defaultMessage: "E-mail"
    },
    profile_phone: {
        id: "profile.phone",
        defaultMessage: "Мобильный телефон"
    },
    profile_confirm_phone: {
        id: "profile.confirm_phone",
        defaultMessage: "Подтвердить номер"
    },
    profile_date: {
        id: "profile.date",
        defaultMessage: "Дата рождения"
    },
    profile_city: {
        id: "profile.city",
        defaultMessage: "Город"
    },
    profile_new_pass: {
        id: "profile.new_pass",
        defaultMessage: "Новый пароль"
    },
    profile_confirm_pass: {
        id: "profile.confirm_pass",
        defaultMessage: "Подтвердите пароль"
    },
    profile_enter_pass: {
        id: "profile.enter_pass",
        defaultMessage: "Введите текущий пароль"
    },
    profile_save: {
        id: "profile.save",
        defaultMessage: "Сохранить"
    },
    profile_country: {
        id: "profile.country",
        defaultMessage: "Страна"
    },
    profile_pass: {
        id: "profile.pass",
        defaultMessage: "Пароль"
    },
    profile_pointed_already: {
        id: "profile.pointed_already",
        defaultMessage: "Данный номер уже используется"
    },
    profile_pointed_email_already: {
        id: "profile.pointed_email",
        defaultMessage: "Данный e-mail уже используется"
    },
    profile_inValid_phoneNumber: {
        id: "profile.inValid_phoneNumber",
        defaultMessage: "Пожалуйста, введите ваш номер телефона в формате {formatCountry}XXXXXXXXX. пример: {formatCountry}555123456"
    },
    profile_inValid_date: {
        id: "profile.inValid_date",
        defaultMessage: "Пожалуйста, введите дату в формате ДД.ММ.ГГГГ"
    }
});
var profileFields = [
    // {
    //   name: "login",
    //   placeholder: "profile_login",
    //   type: "text",
    //   formatMessage: "profile_login"
    // },
    {
        name: "email",
        placeholder: "profile_email",
        type: "email",
        formatMessage: "profile_email"
    },
    {
        name: "firstName",
        placeholder: "profile_name",
        type: "text",
        formatMessage: "profile_name"
    },
    {
        name: "lastName",
        placeholder: "profile_surname",
        type: "text",
        formatMessage: "profile_surname"
    },
    // {
    //   name: "phone",
    //   placeholder: "profile_phone",
    //   type: "number",
    //   formatMessage: "profile_phone"
    // },
    // {
    //   name: "countryId",
    //   placeholder: "profile_country",
    //   type: "text",
    //   formatMessage: "profile_country"
    // },
    {
        name: "Birthdate",
        placeholder: "profile_date",
        type: "date",
        formatMessage: "profile_date"
    },
    // {
    //   name: "city",
    //   placeholder: "profile_city",
    //   type: "text",
    //   formatMessage: "profile_city"
    // }
];
var ProfileForm = /** @class */ (function (_super) {
    __extends(ProfileForm, _super);
    function ProfileForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            buttonDisabled: true,
            isFieldValid: {
                phone: false,
                Birthdate: false
            }
        };
        _this.isPhoneNumber = function (val) {
            var phoneCode = "996";
            if (val.slice(0, 3) !== phoneCode)
                return false;
            var curVal = val.match(/[0-9]/g);
            return curVal && curVal.length >= 12 && curVal.length <= 12;
        };
        _this.checkToFullField = function (value, name) {
            switch (name) {
                case 'phone':
                    var isValidNumber = _this.isPhoneNumber(value);
                    if (!isValidNumber) {
                        _this.setState(function (prev) {
                            var _a;
                            return {
                                isFieldValid: __assign(__assign({}, prev.isFieldValid), (_a = {}, _a[name] = "profile_inValid_phoneNumber", _a))
                            };
                        });
                    }
                    else {
                        _this.setState(function (prev) {
                            var _a;
                            return {
                                isFieldValid: __assign(__assign({}, prev.isFieldValid), (_a = {}, _a[name] = null, _a))
                            };
                        });
                    }
                    return isValidNumber;
                case 'Birthdate':
                    if (!value || value.trim() === '') {
                        return false;
                    }
                    var regEx = /^(\d{2})-(\d{2})-(\d{4})$/;
                    var isValidDate = regEx.test(value);
                    if (!isValidDate) {
                        _this.setState(function (prev) {
                            var _a;
                            return {
                                isFieldValid: __assign(__assign({}, prev.isFieldValid), (_a = {}, _a[name] = "profile_inValid_date", _a))
                            };
                        });
                    }
                    else {
                        _this.setState(function (prev) {
                            var _a;
                            return {
                                isFieldValid: __assign(__assign({}, prev.isFieldValid), (_a = {}, _a[name] = null, _a))
                            };
                        });
                    }
                    return isValidDate;
                default:
                    return !!value.trim();
            }
        };
        _this.fieldProperties = {};
        _this.setFieldProperties = function (event) {
            if (!event || !event.target) {
                console.warn('setFieldProperties: event or event.target is undefined');
                console.trace('Stack trace for undefined event:');
                return;
            }
            _this.fieldProperties[event.target.name] = event.target.value.trim();
            if (!_this.fieldProperties[event.target.name])
                delete _this.fieldProperties[event.target.name];
            var isSomeHasVal = Object.keys(_this.fieldProperties).every(function (key) { return _this.checkToFullField(_this.fieldProperties[key], key); });
            console.log('fieldProperties:', _this.fieldProperties);
            console.log('isSomeHasVal:', isSomeHasVal);
            if (isSomeHasVal) {
                _this.setState({
                    buttonDisabled: false
                });
            }
            else {
                _this.setState({
                    buttonDisabled: true
                });
            }
            if (!Object.keys(_this.fieldProperties).length)
                _this.setState({ buttonDisabled: true });
        };
        _this.getErrorMessage = function (errorNumber) {
            switch (errorNumber) {
                case -2:
                    return {
                        name: "phone",
                        message: _this.props.intl.formatMessage(__assign({}, messages.profile_pointed_already))
                    };
                case -3:
                    return {
                        name: "email",
                        message: _this.props.intl.formatMessage(__assign({}, messages.profile_pointed_email_already))
                    };
                default:
                    return { name: null };
            }
        };
        return _this;
    }
    ProfileForm.prototype.componentWillMount = function () {
        var gambler = this.props.gambler;
        this.props.initialize({ gambler: gambler, city: gambler.city });
    };
    ProfileForm.prototype.render = function () {
        var _this = this;
        var _a = this.props, submitAction = _a.submitAction, handleSubmit = _a.handleSubmit, gambler = _a.gambler, profile = _a.profile, darkTheme = _a.darkTheme;
        var errorMessage = this.getErrorMessage(profile.updateResult);
        var countries = [];
        for (var key in countriesMap) {
            if (countriesMap.hasOwnProperty(key)) {
                countries.push(_jsx("option", __assign({ value: +key }, { children: countriesMap[key] }), key));
            }
        }
        return (_jsxs("form", __assign({ className: "forms", onSubmit: handleSubmit(submitAction), autoComplete: "off" }, { children: [profileFields.map(function (profileField) {
                    if (profileField.name === 'login' && _this.props.user.accountNumber) {
                        return (_jsxs("div", __assign({ style: {
                                border: "1px solid #C2C2BE",
                                display: "flex",
                                justifyContent: "space-between",
                                padding: "14px 10px",
                                marginBottom: "17px"
                            } }, { children: [_jsx("p", __assign({ style: {
                                        fontSize: 14,
                                        fontWeight: 500,
                                        color: darkTheme ? "#fff" : "#000"
                                    } }, { children: _this.props.user.accountNumber })), _jsx("p", __assign({ style: { fontSize: 12 } }, { children: _jsx(FormattedMessage, __assign({}, messages[profileField.formatMessage]), profileField.name) }))] }), profileField.name));
                    }
                    if (gambler[profileField.name]) {
                        if (profileField.name === 'Birthdate') {
                            var date = moment(gambler[profileField.name], "YYYY-MM-DD").format('DD.MM.YYYY');
                            return (_jsxs("div", __assign({ style: {
                                    border: "1px solid #C2C2BE",
                                    display: "flex",
                                    justifyContent: "space-between",
                                    padding: "14px 10px",
                                    marginBottom: "17px"
                                } }, { children: [_jsx("p", __assign({ style: {
                                            color: darkTheme ? "#fff" : "#000",
                                            fontSize: 14,
                                            fontWeight: 500,
                                        } }, { children: _jsx("span", __assign({ style: { fontSize: 'inherit' } }, { children: date })) })), _jsx("p", __assign({ style: { fontSize: 12 } }, { children: _jsx(FormattedMessage, __assign({}, messages[profileField.formatMessage]), profileField.name) }))] }), profileField.name));
                        }
                        return (_jsxs("div", __assign({ style: {
                                border: "1px solid #C2C2BE",
                                display: "flex",
                                justifyContent: "space-between",
                                padding: "14px 10px",
                                marginBottom: "17px"
                            } }, { children: [_jsx("p", __assign({ style: {
                                        color: darkTheme ? "#fff" : "#000",
                                        fontSize: 14,
                                        fontWeight: 500,
                                    } }, { children: profileField.name === "countryId" ? (_jsx("span", __assign({ style: { fontSize: 'inherit' } }, { children: countriesMap[gambler[profileField.name]] }))) : _jsx("span", __assign({ style: { fontSize: 'inherit' } }, { children: gambler[profileField.name] })) })), _jsx("p", __assign({ style: { fontSize: 12 } }, { children: _jsx(FormattedMessage, __assign({}, messages[profileField.formatMessage]), profileField.name) }))] }), profileField.name));
                    }
                    if (profileField.name === "countryId") {
                        return (_jsx(FormattedMessage, __assign({}, messages[profileField.formatMessage], { children: function (m) { return (_jsx(Field, { component: renderSelectField, onChange: _this.setFieldProperties, error: null, name: profileField.name, placeholder: m, type: profileField.type, data: countries })); } }), profileField.name));
                    }
                    if (profileField.name === "Birthdate") {
                        return (_jsx(FormattedMessage, __assign({}, messages[profileField.formatMessage], { children: function (m) { return (_jsx(Field, { component: renderDatePicker, onChange: _this.setFieldProperties, error: profileField.name === errorMessage.name
                                    ? errorMessage.message
                                    : null, name: profileField.name, placeholder: m, type: profileField.type })); } }), profileField.name));
                    }
                    return (_jsxs("div", { children: [_jsx(FormattedMessage, __assign({}, messages[profileField.formatMessage], { children: function (m) { return (_jsx(Field, { component: ProfileInput, onChange: _this.setFieldProperties, error: profileField.name === errorMessage.name
                                        ? errorMessage.message
                                        : null, name: profileField.name, placeholder: m, type: profileField.type })); } }), profileField.name), _this.state.isFieldValid[profileField.name] && (_jsx("div", __assign({ style: { color: 'red', margin: "-10px 0 15px", lineHeight: '16px', maxWidth: '350px' } }, { children: _jsx(FormattedMessage, __assign({}, messages[_this.state.isFieldValid[profileField.name]], { values: { formatCountry: "996" } })) })))] }));
                }), _jsx("div", __assign({ className: "controls" }, { children: _jsx(FormattedMessage, __assign({}, messages.profile_save, { children: function (m) { return (_jsx("button", __assign({ disabled: _this.state.buttonDisabled, type: "submit", name: "save" }, { children: m }))); } })) }))] })));
    };
    return ProfileForm;
}(React.Component));
ProfileForm.propTypes = {
    submitAction: PropTypes.func.isRequired,
    handleSubmit: PropTypes.any.isRequired,
    gambler: PropTypes.object.isRequired,
    intl: PropTypes.object.isRequired
};
ProfileForm = reduxForm({
    form: "profile-form"
})(ProfileForm);
ProfileForm = injectIntl(withRouter(ProfileForm));
export default connect(function (state) { return ({
    darkTheme: state.application.get("darkTheme")
}); })(ProfileForm);



// WEBPACK FOOTER //
// ./src/components/profile/ProfileForm.jsx